import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState } from '../app/store';
import { findAll } from '../services/Service';
import { logger } from '../utils/logger';
import {
  loadPeligrosPersonales,
  setLoadingPeligros,
  setErrorPeligros,
} from '../context/Seguridad/RiesgosReducer';

export const useRiesgos = () => {
  const BASE_URL_PELIGROS = 'peligros';
  const BASE_URL_CONCEPTOS = 'conceptosRiesgo';

  const { peligrosPersonales, loadingPeligros, errorPeligros } =
    useSelector((state: RootState) => state.riesgos);

  const dispatch = useDispatch();

  const obtenerPeligrosPersonales = useCallback(async () => {
    dispatch(setLoadingPeligros(true));
    try {
      const response = await findAll(
        `${BASE_URL_PELIGROS}/tipoPeligro/personales`
      );
      dispatch(loadPeligrosPersonales(response.data));
    } catch (error) {
      logger.error('Error al obtener peligros personales:', logger.safeError(error));
      dispatch(
        setErrorPeligros('Error al cargar los peligros personales')
      );
    } finally {
      dispatch(setLoadingPeligros(false));
    }
  }, [dispatch]);

  const obtenerConceptosExposicion = useCallback(async () => {
    try {
      const response = await findAll(
        `${BASE_URL_CONCEPTOS}/por-tipo/exposicion`
      );
      return response.data; // Devolver directamente los datos
    } catch (error) {
      logger.error(
        'Error al obtener conceptos de exposición:',
        logger.safeError(error)
      );
      return []; // Devolver array vacío en caso de error
    }
  }, []);

  const obtenerConceptosConsecuencia = useCallback(async () => {
    try {
      const response = await findAll(
        `${BASE_URL_CONCEPTOS}/por-tipo/consecuencia`
      );
      return response.data; // Devolver directamente los datos
    } catch (error) {
      logger.error(
        'Error al obtener conceptos de consecuencia:',
        logger.safeError(error)
      );
      return []; // Devolver array vacío en caso de error
    }
  }, []);

  const obtenerConceptosProbabilidad = useCallback(async () => {
    try {
      const response = await findAll(
        `${BASE_URL_CONCEPTOS}/por-tipo/probabilidad`
      );
      return response.data; // Devolver directamente los datos
    } catch (error) {
      logger.error(
        'Error al obtener conceptos de probabilidad:',
        logger.safeError(error)
      );
      return []; // Devolver array vacío en caso de error
    }
  }, []);

  const obtenerPeligrosEntorno = useCallback(async () => {
    try {
      const response = await findAll(
        `${BASE_URL_PELIGROS}/tipoPeligro/entorno`
      );
      return response.data; // Devolver directamente los datos
    } catch (error) {
      logger.error('Error al obtener peligros de entorno:', logger.safeError(error));
      return []; // Devolver array vacío en caso de error
    }
  }, []);

  return {
    peligrosPersonales,
    loadingPeligros,
    errorPeligros,
    obtenerPeligrosPersonales,
    obtenerConceptosExposicion,
    obtenerConceptosConsecuencia,
    obtenerConceptosProbabilidad,
    obtenerPeligrosEntorno,
  };
};
